import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const fetchPortfolioAccounts = createAsyncThunk(
  "portfolioAccount/fetchPortfolioAccounts",
  async ({ clientId, advisorId }, { rejectWithValue }) => {
    try {
      let url = `/account/getUserAccount/${clientId}`;
      if (advisorId) {
        url += `?advisorId=${advisorId}`;
      }

      const response = await getMethod(url);
      const data = await response.json();

      if (!response.ok || data?.error) {
        return rejectWithValue(data?.error || "Failed to fetch user accounts");
      }

      return data;

    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const portfolioAccountSlice = createSlice({
  name: "portfolioAccount",

  initialState: {
    loading: false,
    error: null,
    portfolioAccounts: [],
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchPortfolioAccounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchPortfolioAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.portfolioAccounts = action.payload?.data || [];
      })

      .addCase(fetchPortfolioAccounts.rejected, (state, action) => {
        state.loading = false;
        state.portfolioAccounts = [];
        state.error = action.payload || "Failed to load portfolio accounts";
      });
  },
});

export default portfolioAccountSlice.reducer;
